export default function DirectAnswerBlock() {
  return <section id="direct-answer-block" className="bg-[#F5F3F0] py-16 md:py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="border-l-4 border-secondary pl-6 md:pl-8 py-2">
          <p className="font-serif text-lg md:text-xl text-secondary leading-relaxed">
            Evermark Industrial Solutions provides industrial labeling for electrical contractors — engraved legend plates, panel nameplates, panel schedules, pushbutton plates, and arc flash labels for control panels and electrical equipment. Contractors upload a file or panel layout, approve a proof, and receive install-ready engraved marking, with rush options available when an inspection deadline is close.
          </p>
        </div>
      </div>
    </section>;
}